import React from "react";
import { Card, Tab, Tabs } from "react-bootstrap";
import ManualBet from "./includes/ManualBet";
import AutoBet from "./includes/AutoBet";
import { isMobile } from "../../../Helper";
import styled from "styled-components";

const TabLabel = styled.label`
  &.active {
    border-bottom: 2px solid #ffa900 !important;
    border-radius: 0 !important;
  }
`;

class Bet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bet: "manual",
    };
  }

  componentDidMount() {
    if (isMobile()) {
      this.setState({ padding: "p-1", margin: "mt-1" });
    }
  }

  betMode = (type) => {
    this.setState({ bet: type });
  };

  render() {
    let { margin, bet } = this.state;
    let { isLogged, mobile, engine } = this.props;
    return (
      <>
        <div>
          <div
            className={
              "btn-group btn-group-toggle 'tcr ml-1 mt-1 mb-2" + margin
            }
            data-toggle="buttons"
            style={{ marginBottom: "20px" }}
          >
            <TabLabel
              className={
                "" + bet === "manual" ? "btn 2 btn-xs active" : "btn  btn-xs "
              }
            >
              <input onClick={(e) => this.betMode("manual")} type="radio" />{" "}
              Manual
            </TabLabel>
            {/* <TabLabel
              className={
                "" + bet === "auto" ? "btn btn-xs active" : "btn  btn-xs "
              }
            >
              <input onClick={(e) => this.betMode("auto")} type="radio" /> Auto
            </TabLabel> */}
          </div>

          {bet === "manual" ? (
            <ManualBet engine={engine} mobile={mobile} isLogged={isLogged} />
          ) : (
            <AutoBet engine={engine} isLogged={isLogged} />
          )}
          <div>
            <span style={{ fontSize: 11, marginLeft: 5 }}>
              {this.props.coin === "INR"
                ? "(Minimum Bet - 20 INR)"
                : "(Minimum Bet - 0.5 USDT)"}
            </span>
          </div>
        </div>
      </>
    );
  }
}

export default Bet;
